// extracted by mini-css-extract-plugin
module.exports = {"header":"products_header__3WnU1","table":"products_table__1t-gi","emptyTips":"products_emptyTips__1y6Ah","img":"products_img__2oEyK","text":"products_text___UPUV"};